import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { BUTTON__CONTENT_CLASS } from '../constants';
import { baseButton, baseLink } from '../styles/base.styles';

const { fonts, responsiveText, spacing } = theme;

export const textButtonStyle = css`
  border-radius: ${pxToRem(6)};
  padding: ${spacing.base}px ${spacing.xs}px;

  .${BUTTON__CONTENT_CLASS} {
    color: var(--neutral-black-base);
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    ${responsiveText.BODY.SM};
    height: ${pxToRem(28)};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    position: relative;

    &::after {
      border-bottom: solid ${pxToRem(1)} var(--neutral-black-base);
      bottom: ${pxToRem(3)};
      content: '';
      display: block;
      position: absolute;
      width: 100%;
    }
  }

  @media (hover: hover) {
    &:hover {
      background-color: var(--neutral-black-10);
      .${BUTTON__CONTENT_CLASS} {
        color: var(--brand-purple-base);

        &::after {
          border-bottom: solid ${pxToRem(1)} var(--brand-purple-base);
        }
      }
    }
  }

  &:active {
    background-color: var(--brand-purple-30);

    .${BUTTON__CONTENT_CLASS} {
      color: var(--brand-purple-base);

      &::after {
        border-bottom: solid ${pxToRem(1)} var(--brand-purple-base);
      }
    }
  }

  &.focus-visible:focus {
    -webkit-box-shadow: inset 0 0 0 ${pxToRem(2)} var(--brand-bluple-base),
      inset 0 0 0 ${pxToRem(4)} var(--neutral-white-base);
    box-shadow: inset 0 0 0 ${pxToRem(2)} var(--brand-bluple-base),
      inset 0 0 0 ${pxToRem(4)} var(--neutral-white-base);
    border-radius: ${pxToRem(8)};

    .${BUTTON__CONTENT_CLASS} &:not(:hover) {
      color: var(--neutral-black-base);
    }
  }

  &[data-is-active='true'] {
    background-color: var(--neutral-black-10);
  }
`;

export const textButton = css`
  ${baseButton}
  ${textButtonStyle}
`;

export const textButtonLink = css`
  ${baseLink}
  ${textButtonStyle}
`;
